export default __webpack_public_path__ + "img/33ba0d9ddc8bbdc2bc69c08806fe4cd3.png";